import { render, staticRenderFns } from "./MarketplaceSales.vue?vue&type=template&id=13142ddf"
import script from "./MarketplaceSales.vue?vue&type=script&lang=js"
export * from "./MarketplaceSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports